import { createApiCall } from 'lib/base';

const FETCH_HOME_WIDGET_CREATE_API_ID = 'DASHBOARD/FETCH_HOME_WIDGET_CREATE_API';

const apiCall = createApiCall(FETCH_HOME_WIDGET_CREATE_API_ID, ({ payload }) => ({
  endpoint: `/api/admin/home-widgets`,
  method: 'POST',
  body: payload,
  notify: true,
}));

export default apiCall;
